import React from "react";

const BuyerFaqContent = [
  {
    title: "What is Lighter Advisory?",
    content:
      "Lighter Advisory is a real estate advisory primarily focused on creating a delightful customer experience. We walk with you through the entire journey of finding, exploring and buying or renting the perfect property as per your needs.",
  },

  {
    title: "Why Lighter Advisory?",
    content:
      "We realise that finding a property is not an easy task. Lighter Advisory came into existence to simplify the real estate transaction experience. Lighter Advisory provides the entire gamut of real estate services, and it is the only stop you ever need to visit for your real estate needs.",
  },
  {
    title: "What does Lighter Advisory mean?",
    content: (
      <span>
        <span>
          Lighter Advisory in the Kannada language means a close relationship
          formed people. Building this cordial relationship between people is
          possible only if both parties are introduced to each other in the
          right manner. We at Lighter Advisory believe that any real estate
          transaction needs to be cordial, transparent and respectful, and we
          help you connect with your future clients so you can build and
          everlasting relationship.
        </span>
        <br></br>
        <br></br>
        <span>
          Lighter Advisory is a prop-tech startup which originated from the
          Silicon Valley of India, Bengaluru. Lighter Advisory was built by a
          young and relentless technology-focused team that wanted to
          revolutionize real estate.
        </span>
        <br></br>
        <br></br>
        <span>
          Lighter Advisory initially started by selling homes and proudly handed
          over hundreds of keys to customer’s dream homes.
        </span>
        <br></br>
        <br></br>
        <span>
          <b>Beeg</b>ad Kai (Meaning ‘Key’ in Kannada) + Bengaluru ( City of
          Origin ) =<b> Lighter Advisory</b>
        </span>
      </span>
    ),
  },

  {
    title: "What does Lighter Advisory charge for its services?",
    content:
      "We do not charge customers if the property is sold through a developer. Lighter Advisory charges customers only if it is a resale property, landowner property or an independent property. We charge either side for rentals and other property related transaction facilitation.Our other value-added services such as legal services, documentation, etc., will be charged on mutually agreed terms.",
  },
  {
    title: "How can I get in touch with Lighter Advisory?",
    content:
      "You can call us, and we will assign a dedicated Property Advisor to you, who will help you with your property needs.",
  },
  {
    title: "How do I post my property requirements on Lighter Advisory?",
    content:
      "You can call us and give us the property requirement details and we will begin your search. You can also upload your property requirements on our website here.",
  },
  {
    title: "How to contact Lighter Advisory customer care?",
    content:
      "Call Lighter Advisory Customer Happiness Centre Toll Free at 18005720999 or you can WhatsApp us on +91 9980775599.",
  },
  {
    title:
      "Where can I report about the wrong information posted about a property/project listing? Or whom should I contact if I face any issues?",

    content:
      "You can call or WhatsApp us at +91 99807 75599 or mail us at mail@Lighter Advisory.com",
  },
  {
    title: "How can Lighter Advisory help me with choosing the property?",
    content: (
      <span>
        <ol>
          <li>
            Call us and let us know your requirements or check out our website.
          </li>
          <li>
            If you choose to check our website, select the property that meets
            your criteria and drop an inquiry / let us know if you have any
            unique requirements.
          </li>
          <li>
            Our team will analyse your requirements and suggest you a list of
            properties.
          </li>
          <li>
            You can go on a site visit of the selected properties with our
            relationship managers who will explain all the properties in detail,
            so you can make the right decision.
          </li>
          <li>
            After you book the property, Lighter Advisory can also help you with
            the transaction, property loan assistance, registration process and
            interiors.
          </li>
        </ol>
      </span>
    ),
  },
  {
    title: "Based on what parameters does Lighter Advisory suggest properties?",
    content: (
      <span>
        We analyse your requirement based on a few metrics such as:
        <ol>
          <li>Location</li>
          <li>Pricing</li>
          <li>
            Type of property you are comfortable with (Eg: Apartment, Villa,
            etc.)
          </li>
          <li>Amenities you need/want</li>
          <li>Civic infrastructure ( Eg: Metro, Highway connection, etc.,)</li>
          <li>
            Purpose of buying the property (Eg: end-use, rental income,
            investment)
          </li>
          <li>Any unique requirements that you have</li>
        </ol>
      </span>
    ),
  },
  {
    title: "Do you offer home loan services?",
    content: "Yes, we facilitate home loan services.",
  },
  {
    title: "What other value-added services does Lighter Advisory provide?",
    content:
      "Lighter Advisory assists you with services such as legal, documentation, loan facilitation, liaising, civil construction, interior design, architectural services, NRI property assistance and professional accountant services. If you require any specific real estate service, please get in touch with us.",
  },
  {
    title: "In which cities do you offer your services?",
    content:
      "Bengaluru and Mysuru. Yet you can send us your requirements from anywhere in the world. In the meanwhile, we can connect you to our associates in your location.",
  },
  {
    title: "How can Lighter Advisory.com help an NRI buy a property in India?",
    content:
      "You can call or WhatsApp us at +91 99807 75599 or mail us at mail@Lighter Advisory.com",
  },
  {
    title: "Are you from the Developer's side or Agent?",
    content:
      "We are registered Channel Partners with all developers and landowners. We furnish project details, facilitate site visits and walk you through the entire process of buying or renting the perfect property as per your needs.",
  },
  {
    title:
      "Why should I take Lighter Advisory’s assistance rather than reaching out to developers directly?",
    content:
      "We came into existence with the idea of bringing transparency in real estate, so you can have all the facts about all the properties in one platform. We know what is the best deal that the developer can offer you on any project, hence we ensure that you get a better deal through us than anyone else. We know vicinities better than anyone in the market, as we are associated with a lot of developers & landowners in various neighborhoods. With our network and experience, we can help you to select the right property at the right price.",
  },
  {
    title: "Does Lighter Advisory deal with disputed property?",
    content:
      "No. Lighter Advisory does not deal with properties with any legal dispute. We want to make the experience of real estate, hassle free.",
  },
];

export default BuyerFaqContent;
